export default __webpack_public_path__ + "static/media/MCT.89a9572a.svg";